import type { ReactNode } from 'react';

import { PageHeader } from '../../components/PageHeader';
import { SectionTabs } from '../../components/SectionTabs';

const OPERATIONS_NAV = [
  { to: '/operations/sync-health', label: 'การซิงก์' },
  { to: '/payments/reconciliation', label: 'กระทบยอด' },
  { to: '/payments/evidence', label: 'หลักฐานโอน' },
  { to: '/devices/health', label: 'เครื่อง POS' },
  { to: '/operations/price-checkers', label: 'จุดเช็กราคา' },
  { to: '/operations/backups', label: 'ข้อมูลสำรอง' },
] as const;

type StatusTone = 'ok' | 'warn' | 'danger' | 'neutral';

export function OperationsHeader({
  title,
  subtitle,
  actions,
  status,
}: {
  title: ReactNode;
  subtitle: ReactNode;
  actions?: ReactNode;
  status?: { label: string; tone: StatusTone };
}) {
  return (
    <div className="mb-6">
      <PageHeader
        title={title}
        subtitle={subtitle}
        actions={actions}
        status={status}
      />
      <SectionTabs items={OPERATIONS_NAV} label="เมนูศูนย์ปฏิบัติการ" />
    </div>
  );
}
